import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CreateComponent } from "./components/create/create.component";
import { FilledPrescriptionComponent } from "./components/filled-prescription/filled-prescription.component";
import { PrescriptionsComponent } from "./components/prescriptions/prescriptions.component";
import { ViewPrescriptionComponent } from "./components/view-prescription/view-prescription.component";
import { PrescriptionComponent } from "./prescription.component";
import { PrescripitonTokenComponent } from './components/prescripiton-token/prescripiton-token.component';
const routes: Routes = [
  {
    path: "",
    component: PrescriptionComponent,
    children: [
      { path: "", redirectTo: "list", pathMatch: "full" },
      { path: "list", component: PrescriptionsComponent },
      { path: "create", component: CreateComponent },
      { path: "view", component: ViewPrescriptionComponent },
      { path: "fill", component: FilledPrescriptionComponent },
      { path: "prescripitontoken", component: PrescripitonTokenComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PrescriptionRoutingModule {}
